<template>
	<JBox class="s-flex-col s-w-full s-h-full">
		<AppThemeFrame :themeProperties="this.properties" :selectedProperty="selectedProperty" @selectProperty="selectProperty">
			<!-- Theme property slots -->
			<JBox class=" s-flex-col s-w-full s-border-r-2 s-border-gray-300 s-px-5 s-overflow-y-scroll" style="height: 70vh">
				<AppThemeSlotMenu
					:selectedProperty="selectedProperty"
					:themeConfigString="config.themeJsonString"
					@updateTheme="updateConfig"
				/>
			</JBox>

			<!-- Buttons -->
			<JFlex
				class="s-w-full s-justify-center s-items-center s-py-5 s-border-t-4 s-border-purple-300 s-bg-gray-100 s-rounded-b-lg"
			>
				<JBox class="s-mx-12">
					<JButton @click="submitChanges"> {{ $t("uiEditor.save") }} </JButton>
				</JBox>
				<JBox class="s-mx-12">
					<JButton variant="white" @click="$emit('cancelled')">
						{{ $t("uiEditor.cancel") }}
					</JButton>
				</JBox>
			</JFlex>
			<JBox v-if="errorMessage" class="s-bg-red-100 s-text-red-700 s-text-center s-p-4">
				{{ errorMessage }}
			</JBox>
		</AppThemeFrame>
	</JBox>
</template>

<script>
import AppThemeFrame from "./AppThemeFrame"
import AppThemeSlotMenu from "./AppThemeSlotMenu"

// TODO: theme needs refactor
export default {
	components: {
		AppThemeFrame,
		AppThemeSlotMenu
	},

	props: {
		appId: {
			type: String
		}
	},

	data() {
		return {
			isLoading: false,
			errorMessage: "",

			config: { themeJsonString: "" },
			updatedConfig: {},

			selectedProperty: "colors",

			// Theme properties selectable: (as tags)
			properties: [
				{ id: "colors", label: this.$t("uiEditor.colors") },
				{ id: "shadows", label: this.$t("uiEditor.shadows") },
				{ id: "typeFaces", label: this.$t("uiEditor.typeFaces") },
				{ id: "customCss", label: this.$t("uiEditor.customCss") }
			]
		}
	},

	methods: {
		initConfig() {
			this.config.themeJsonString = this.$store?.state?.uiEditor?.app?.themeJsonString ?? ""
		},

		// To switch property @click tags
		selectProperty(val) {
			this.selectedProperty = val
		},

		// Sync all changes in modal here before submit
		updateConfig(val) {
			this.updatedConfig = JSON.stringify(val)
		},

		async handleThemeUpdate() {
			this.errorMessage = "" // reset

			const { isSuccess } = await this.$store.dispatch("uiEditor/updateTheme", {
				appId: this.appId,
				themeJsonString: this.updatedConfig
			})

			if (!isSuccess) {
				// TODO: provide beter error message from API
				this.errorMessage = "Oops, there was an unexpected error."
				return
			}

			this.$emit("updated")
		},

		submitChanges() {
			this.handleThemeUpdate()
		}
	},

	mounted() {
		this.initConfig()
	}
}
</script>
